import {
  faArrowDown,
  faArrowUp,
  faComment
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reduce } from "et3-type-guards";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import UserSaveIcon from "./UserSaveIcon";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Et3TextInput from "../../../../../core/et3-input/et3-text-input";
import ET3Div from "../../../../../core/et3-div";

const UserAddCommentsTable = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY, getFontSize } = theme;
  const userID = getUserAdvancedStore().currentUserId.get();
  const commentsNumber = reduce(
    () => getUserAdvancedStore().userData.get(userID).commentsNumber,
    0
  );
  const showComments = getUserAdvancedStore().showComments.get();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1470}
      height={100}
      fDirection="row"
      alignItems="center"
      justifyContent="space-between"
      color={colors.all.transparent}
      onClick={() => {}}
      style={{}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={200}
        height={100}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          text={i18n.get("USER_ALL_COMMENTS")}
          fontFamily="MEDIUM"
          fontSize={14}
          color={colors.all.black}
          isSpan={true}
          style={{}}
        />
        <Et3Margin left={5} right={0} top={0} bottom={0} />
        <Et3Text
          text={`${commentsNumber}`}
          fontFamily="BOLD"
          fontSize={14}
          color={colors.all.red}
          isSpan={true}
          style={{}}
        />
        <Et3Margin left={20} right={0} top={0} bottom={0} />
        <FontAwesomeIcon
          className="clickable"
          onClick={() => {
            getUserAdvancedStore().showComments.set(!showComments);
          }}
          icon={showComments ? faArrowUp : faArrowDown}
          color={colors.all.green}
          style={{ fontSize: getFontSize(21) }}
          size="1x"
        />
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1270}
        height={100}
        fDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          withShadow={true}
          icon={faComment}
          type={"textarea"}
          label={""}
          size="EXTRA_LARGE"
          placeHolder={i18n.get("ADD_COMMENT")}
          value={getUserAdvancedStore().adminCommentText.get()}
          onChoose={(target: string) => {
            getUserAdvancedStore().setAdminUserComment(target);
          }}
          onBlur={() => {}}
          onEnter={() => {}}
          style={{
            width: 1200 * unitY
          }}
        />
        <Et3Margin left={20} right={0} top={0} bottom={0} />
        <UserSaveIcon />
      </ET3Div>
    </ET3Div>
  );
});
export default UserAddCommentsTable;
